/**
 * @generated SignedSource<<c7754dbab1818ebe114778193645d76c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type DistributionStatus = "ACTIVE" | "INACTIVE" | "%future added value";
export type GroupContentJudgeStatus = "PENDING" | "APPROVED" | "%future added value";
export type PageKind = "LANDING" | "FORM" | "CONFIRM" | "THANKS" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PopupGroupSetDetailLinkedPopupGroupListTable_popupGroupSet$data = {
  readonly id: string;
  readonly popupGroupSettings: {
    readonly __id: string;
    readonly totalCount: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly popupGroup: {
          readonly id: string;
          readonly slug: string;
          readonly name: string;
          readonly status: DistributionStatus;
          readonly thumbnailImageUrl: string | null;
          readonly judgeStatus: GroupContentJudgeStatus | null;
          readonly page: {
            readonly id: string;
            readonly kind: PageKind;
            readonly name: string;
            readonly url: string;
            readonly sortNumber: number;
            readonly funnel: {
              readonly id: string;
              readonly name: string;
              readonly siteUrl: string;
            };
          };
          readonly " $fragmentSpreads": FragmentRefs<"PopupGroupBulkEditFormContainer_popupGroup">;
        };
      } | null;
    } | null> | null;
  };
  readonly " $fragmentType": "PopupGroupSetDetailLinkedPopupGroupListTable_popupGroupSet";
};
export type PopupGroupSetDetailLinkedPopupGroupListTable_popupGroupSet = PopupGroupSetDetailLinkedPopupGroupListTable_popupGroupSet$data;
export type PopupGroupSetDetailLinkedPopupGroupListTable_popupGroupSet$key = {
  readonly " $data"?: PopupGroupSetDetailLinkedPopupGroupListTable_popupGroupSet$data;
  readonly " $fragmentSpreads": FragmentRefs<"PopupGroupSetDetailLinkedPopupGroupListTable_popupGroupSet">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "popupGroupSettings"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 120,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./PopupGroupSetDetailLinkedPopupGroupListTableRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "PopupGroupSetDetailLinkedPopupGroupListTable_popupGroupSet",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "popupGroupSettings",
      "args": null,
      "concreteType": "PopupGroupSettingConnection",
      "kind": "LinkedField",
      "name": "__PopupGroupSetDetailLinkedPopupGroupListTable_popupGroupSet_popupGroupSettings_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PopupGroupSettingEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PopupGroupSetting",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PopupGroup",
                  "kind": "LinkedField",
                  "name": "popupGroup",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slug",
                      "storageKey": null
                    },
                    (v2/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "thumbnailImageUrl",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "judgeStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Page",
                      "kind": "LinkedField",
                      "name": "page",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "kind",
                          "storageKey": null
                        },
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sortNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Funnel",
                          "kind": "LinkedField",
                          "name": "funnel",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            (v2/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "siteUrl",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PopupGroupBulkEditFormContainer_popupGroup"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PopupGroupSet",
  "abstractKey": null
};
})();

(node as any).hash = "78e23ae2489e0eb3c8fa58480d0b48cf";

export default node;
